// extracted by mini-css-extract-plugin
module.exports = {"errors":"Errors_errors__1oFqS","errors__item":"Errors_errors__item__1ickD"};